import React, { FC, useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { ArrowLeft, ArrowRight, X } from "lucide-react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { ChevronRight } from "lucide-react";


import toast from "react-hot-toast";
import {
  CancellationReasonTypes,
  ExamsDetailsTypes,
  ExamsTypes,
} from "../../../interfaces/exams.interface";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseServiceUrl, urls } from "../../../environment";
import { FeatureCard } from "../FeatureCard";
import { ExaminationSlide } from "../ExaminationSlide";
import { Button } from "@mui/material";
import ResultQAReport from "../ResultQAReport";
import PageLoader from "../../../components/Loader/PageLoader";
import { formatDateTime } from "../../../utils";
import useUserStore from "../../../stores/useUserStores";
import { UserContext } from "../../../context/UserContext";

type MyResultSectionProps = {
  fromScrutinyCreate?: boolean;
  refreshList?: () => void;
};
const MyResultSection: FC<MyResultSectionProps> = ({
  fromScrutinyCreate,
  refreshList,
}): JSX.Element => {
  const errornotify = (msg: any) => toast.error(msg);
  const [currentTime, setCurrentTime] = useState<{
    date: string;
    time: string;
  }>({
    date: "",
    time: "",
  });
  // const userDetails: any = useUserContext();
  const [examsPageIndex, setExamsPageIndex] = useState<number>(0);
  const [examsPageSize, setExamsPageSize] = useState<number>(6);
  const [rows, setRows] = useState<Array<any>>([]);
  const [examsets, setexamsets] = useState<ExamsTypes>({
    count: 0,
    page_index: 0,
    page_size: 0,
    resp: [],
    current_datetime: "",
  });
  const Navigate = useNavigate();

  const {
    userdetail,
    setLoading,
    token,
    fullscreenmode,
    setFullScreenMode,
    setExam,
    exam,
    setExamStarted,
    examStarted,
    examQuestionDetails,
    setExamQuestionDetails,
    setStartExamMessage,
    loading,
    startExamMessage,
    resumeDuration,
    setResumeDuration,
  } = useUserStore();
  const { handleFullscreenChange, enterFullscreen }: any =
    useContext(UserContext);

  const [searchedText, setSearchText] = useState<string>("");

  const [cancellationDetails, setCancellationDeatails] = useState<
    Array<CancellationReasonTypes>
  >([]);
  const [selectedExamForScrutiny, setSelectedExamForScrutiny] = useState<
    ExamsDetailsTypes | undefined | null
  >(null);
  const handleChangePage = (event: unknown, newPage: number) => {
    setExamsPageIndex(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setExamsPageSize(+event.target.value);
    setExamsPageIndex(0);
  };
  const requestSearch = (searchedVal: string) => {
    const filteredRows =
      !!examsets && examsets?.resp && Array.isArray(examsets?.resp)
        ? examsets?.resp
            ?.filter(
              (self) =>
                self?.status === "PUBLISHED" &&
                self?.is_associted_with_questions === true
            )
            .filter((frows: any) => {
              return (
                frows?.title
                  ?.toLowerCase()
                  .includes(searchedVal?.trim()?.toLowerCase()) ||
                frows.exam_group_title
                  ?.toLowerCase()
                  .includes(searchedVal?.trim()?.toLowerCase())
              );
            })
        : [];

    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearchText("");
    requestSearch("");
  };
  useEffect(() => {
    if (examsets && examsets?.resp) cancelSearch();
  }, [examsets]);
  useEffect(() => {
    if (examsets.current_datetime) {
      const result = formatDateTime(examsets.current_datetime);

      setTimeout(() => {
        setCurrentTime(result);
      }, 2000);
    }
  }, [examsets]);
  useEffect(() => {
    if (!userdetail) return;
    (async () => {
      try {
        setLoading(true);

        const response = await axios.post(
          baseServiceUrl + urls.getAllExamUrl,
          {
            search_string: "PUBLISHED",
            page_index: examsPageIndex,
            page_size: examsPageSize,
            user_type: "Examinee",
            email: userdetail.email,
            user_id: userdetail.id,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          setexamsets(response.data);
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  }, [userdetail, examsPageIndex]);

  //  *************************  Resume Test ************************************
  const resumeTest = (item: any) => {
    (async () => {
      try {
        setLoading(true);
        let payload = {
          exam_id: item.id,
          user_id: userdetail.id,
        };
        const response = await axios.post(
          baseServiceUrl + urls.resumeExam,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setStartExamMessage(
            response?.data?.message ?? "Examination resumed successfully"
          );

          setExam({
            ...exam,

            ...item,
            exam_session: response.data?.session_id,
          });

          //  ToDo:// *************************************   need to discuss with sajal daa *********************************************
          if (response.data && response.data?.duration)
            setResumeDuration(response.data?.duration);
          if (
            response.data &&
            response.data?.questions &&
            Array.isArray(response.data?.questions)
          ) {
            const _tempQuestions = response.data.questions.map((self: any) => ({
              ...self,
              ans_id: self?.selected_option,
              status: self?.question_status,
            }));
            const _tempDetails = JSON.parse(
              JSON.stringify({
                ...response.data,
                questions: _tempQuestions,
              })
            );
            setExamQuestionDetails(_tempDetails);
          } else {
            setExamQuestionDetails(response.data);
          }

          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  // **********************  Start Test ***********************************

  const startTest = (item: any) => {
    (async () => {
      try {
        setLoading(true);
        let payload = {
          exam_id: item.id,
          user_id: userdetail.id,
        };
        const response = await axios.post(
          baseServiceUrl + urls.examStartUrl,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setStartExamMessage(
            response?.data?.message ?? "Examination started successfully"
          );

          setExam({
            ...exam,
            ...item,
            exam_session: response.data?.session_id,
          });
          setExamQuestionDetails(response.data);
          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };
  if (loading) return <PageLoader loading />;
  return (
    <div className="grid grid-cols-12 pb-10 mt-5">
      <ResultQAReport
        refreshList={refreshList}
        examsDetailsTypes={selectedExamForScrutiny}
        handleClose={() => setSelectedExamForScrutiny(null)}
        cancellationDetails={cancellationDetails}
        setCancellationDeatails={setCancellationDeatails}
      />

      <div className={` col-span-12 mb-2 `}>
        <div className="px-4 w-full">
          <div className="flex flex-col lg:flex-row justify-between lg:items-center bg-gray-100 px-5 py-2 rounded-t-lg border border-gray-100 shadow-sm">
            <h2 className="text-sm lg:text-xl font-bold text-gray-700">
              {fromScrutinyCreate ? `Choose Your Paper` : `Result Published`}
            </h2>
            {/* <div className="  flex items-center relative w-[350px] lg:mt-0 mt-5   ">
              <input
                type="text"
                value={searchedText}
                onChange={(event: any) => (
                  setSearchText(event.target.value),
                  requestSearch(event.target.value)
                )}
                className="py-2 rounded-tl-md rounded-bl-md w-[97%] pr-12 border px-3 focus:border-blue-500 outline-none "
                placeholder="Search Exams Here..."
              />
              {searchedText.length ? (
                <X
                  className="size-5 absolute top-[25%] text-gray-500 right-[25%] cursor-pointer"
                  onClick={cancelSearch}
                />
              ) : (
                <></>
              )}

              <div
                className="w-[80px] h-full py-[1px] flex items-center justify-center rounded-tr-md rounded-br-md cursor-pointer bg-[#2563EB]"
                onClick={() => requestSearch(searchedText.trim())}
              >
                <IconButton>
                  <SearchIcon sx={{ color: "#fff" }} />
                </IconButton>
              </div>
            </div> */}
          </div>
          <div className="bg-gray-50/50 px-5 py-6 rounded-b-lg border border-gray-100 border-t-0">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-5">
              {examsets &&
              examsets.total_count &&
              Array.isArray(examsets?.resp) ? (
                examsets?.resp.map((exam, key) => (
                  <ExaminationSlide
                    details={exam}
                    indexNum={key}
                    key={key}
                    startTest={startTest}
                    resumeTest={resumeTest}
                    setSelectedExamForScrutiny={setSelectedExamForScrutiny}
                    refreshList={refreshList}
                    currentDateTime={examsets.current_datetime}
                    currentTime={currentTime}
                  />
                ))
              ) : (
                <></>
              )}
              {examsets.total_count === 0 && !loading ? (
                <div className="mt-[15vh] text-gray-700 text-center w-full col-span-12">
                  No Exam Found
                </div>
              ) : loading ? (
                <div className="mt-[15vh] text-gray-700 text-center w-full col-span-12">
                  Please wait we are fetching the result ....
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-span-12   ">
        <div
          className={` mt-2 mx-auto  md:w-[95%] w-[80%]  flex items-center md:justify-end ${
            examsets?.total_count &&
            examsets?.total_count >
              examsPageSize * examsPageIndex + examsPageSize &&
            examsets?.resp?.length
              ? `justify-between`
              : `justify-end`
          }  gap-x-2   bg-white  `}
        >
          {examsets?.total_count &&
          examsets?.total_count > examsPageIndex &&
          examsPageIndex > 0 ? (
            <button
              onClick={() => setExamsPageIndex((prev) => prev - 1)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-lg font-semibold flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <ArrowLeft className="h-5 w-5" />
              <span className="hidden sm:block">Prev</span>
            </button>
          ) : (
            <></>
          )}
          {examsets?.total_count &&
          examsets?.total_count >
            examsPageSize * examsPageIndex + examsPageSize &&
          examsets?.resp?.length ? (
            <button
              onClick={() => setExamsPageIndex((prev) => prev + 1)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-lg font-semibold flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <span className="hidden sm:block">Next</span>
              <ArrowRight className="h-5 w-5" />
            </button>
          ) : (
            // <Button
            //   variant="contained"
            //   className=""
            //
            //   endIcon={<KeyboardArrowRightIcon />}
            // >
            //   next
            // </Button>
            <></>
          )}
          {/* {
                    !!examsets && examsets
                  }
                     */}
        </div>
      </div>
    </div>
  );
};

export default MyResultSection;
